$(function () {
  $('.pageFaq01__faqList__ttl').on('click', function () {
    $(this).toggleClass('is_open');
    $(this).next().slideToggle();
  });
});
